var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, useRef } from "react";
import { createChatSession as createChatSessionAPI, fetchToolPacks, fetchRegisteredUsers, } from "./api";
import { PlaygroundURLBar } from "./components/PlaygroundURLBar";
import { ChatMessages } from "./components/ChatMessages";
import { ChatInput } from "./components/ChatInput";
import { SettingsPanel } from "./components/SettingsPanel";
import { PlaygroundConfirmDialog } from "./components/PlaygroundConfirmDialog";
import { sendOpenLinkToParent, sendOpenInToParent, sendSelectionChangeToParent, AH_PARENT_LINK_SUCCESS_TO_IFRAME, AH_PARENT_LINK_EXIT_TO_IFRAME, } from "./utils/messageUtils";
import { isAuthenticateTool } from "./utils/toolUtils";
import { Card, Text } from "@merge-api/merge-javascript-shared";
import clsx from "clsx";
export var ChatWidget = function (_a) {
    var authToken = _a.authToken, apiBaseURL = _a.apiBaseURL, useDummyResponse = _a.useDummyResponse, customization = _a.customization, onMessagesChange = _a.onMessagesChange, meUser = _a.meUser;
    var initialToolPackId = customization === null || customization === void 0 ? void 0 : customization.initialToolPackId;
    var initialRegisteredUserId = customization === null || customization === void 0 ? void 0 : customization.initialRegisteredUserId;
    var _b = useState([]), messages = _b[0], setMessages = _b[1];
    var _c = useState(""), inputValue = _c[0], setInputValue = _c[1];
    var _d = useState(false), isLoading = _d[0], setIsLoading = _d[1];
    var _e = useState(null), chatSession = _e[0], setChatSession = _e[1];
    var _f = useState(false), isCreatingSession = _f[0], setIsCreatingSession = _f[1];
    var _g = useState(false), isSettingsPanelOpen = _g[0], setIsSettingsPanelOpen = _g[1];
    var _h = useState([]), toolPacks = _h[0], setToolPacks = _h[1];
    var _j = useState([]), registeredUsers = _j[0], setRegisteredUsers = _j[1];
    var _k = useState(null), selectedToolPackId = _k[0], setSelectedToolPackId = _k[1];
    var _l = useState(null), selectedRegisteredUserId = _l[0], setSelectedRegisteredUserId = _l[1];
    var _m = useState(false), isLoadingResources = _m[0], setIsLoadingResources = _m[1];
    var _o = useState("max-w-2xl"), compactModeWidth = _o[0], setCompactModeWidth = _o[1];
    var _p = useState(""), additionalSystemPrompt = _p[0], setAdditionalSystemPrompt = _p[1];
    var eventSourceRef = useRef(null);
    var _q = useState(false), confirmDialogOpen = _q[0], setConfirmDialogOpen = _q[1];
    var pendingChangeRef = useRef(null);
    // Notify parent when messages change
    // Wait for 2 messages (user + assistant response) before triggering
    useEffect(function () {
        onMessagesChange === null || onMessagesChange === void 0 ? void 0 : onMessagesChange(messages.length >= 2);
    }, [messages, onMessagesChange]);
    // Handle window resize for compact mode width
    useEffect(function () {
        var updateCompactModeWidth = function () {
            var width = window.innerWidth;
            if (width < 640) {
                setCompactModeWidth("max-w-full");
            }
            else if (width < 768) {
                setCompactModeWidth("max-w-xl");
            }
            else if (width < 1024) {
                setCompactModeWidth("max-w-2xl");
            }
            else {
                setCompactModeWidth("max-w-3xl");
            }
        };
        // Set initial width
        updateCompactModeWidth();
        // Add resize listener
        window.addEventListener("resize", updateCompactModeWidth);
        return function () { return window.removeEventListener("resize", updateCompactModeWidth); };
    }, []);
    // Listen for messages from the parent window
    useEffect(function () {
        var handleMessage = function (event) { return __awaiter(void 0, void 0, void 0, function () {
            var _a, messageType, publicToken, continuationText;
            return __generator(this, function (_b) {
                _a = event.data, messageType = _a.messageType, publicToken = _a.publicToken;
                switch (messageType) {
                    case AH_PARENT_LINK_SUCCESS_TO_IFRAME:
                        console.log("Link authentication successful. Sending continuation message...");
                        // Update the authenticate call message to show success badge
                        setMessages(function (prev) {
                            return prev.map(function (msg) {
                                if (msg.parts) {
                                    var updatedParts = msg.parts.map(function (part) {
                                        if (part.type === "authenticateCall") {
                                            return __assign(__assign({}, part), { authenticateCall: __assign(__assign({}, part.authenticateCall), { isConnected: true }) });
                                        }
                                        return part;
                                    });
                                    return __assign(__assign({}, msg), { parts: updatedParts });
                                }
                                return msg;
                            });
                        });
                        // Send continuation message after successful authentication (without displaying it)
                        if (chatSession) {
                            continuationText = "The user has successfully authenticated. Continue";
                            // Show loading indicator
                            setIsLoading(true);
                            // Stream the response without adding user message to UI
                            handleStreamingResponse(continuationText, chatSession);
                        }
                        break;
                    case AH_PARENT_LINK_EXIT_TO_IFRAME:
                        console.log("Link authentication exited without completion");
                        // TODO: Show message to user that authentication was cancelled
                        break;
                    default:
                        // Ignore other message types
                        break;
                }
                return [2 /*return*/];
            });
        }); };
        window.addEventListener("message", handleMessage);
        return function () { return window.removeEventListener("message", handleMessage); };
    }, [chatSession]);
    // Fetch tool packs and registered users on mount
    useEffect(function () {
        var fetchResources = function () { return __awaiter(void 0, void 0, void 0, function () {
            var _a, allToolPacks, allRegisteredUsers, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (useDummyResponse)
                            return [2 /*return*/];
                        setIsLoadingResources(true);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, Promise.all([
                                fetchToolPacks(apiBaseURL, authToken),
                                fetchRegisteredUsers(apiBaseURL, authToken),
                            ])];
                    case 2:
                        _a = _b.sent(), allToolPacks = _a[0], allRegisteredUsers = _a[1];
                        setToolPacks(allToolPacks);
                        setRegisteredUsers(allRegisteredUsers);
                        // PRIORITY 1: Use initialToolPackId if provided (from playground navigation)
                        if (initialToolPackId &&
                            allToolPacks.some(function (tp) { return tp.id === initialToolPackId; })) {
                            setSelectedToolPackId(initialToolPackId);
                        }
                        // PRIORITY 2: Use user's preferred tool pack if it exists and is in the list
                        else if ((meUser === null || meUser === void 0 ? void 0 : meUser.preferred_tool_pack_id) &&
                            allToolPacks.some(function (tp) { return tp.id === meUser.preferred_tool_pack_id; })) {
                            setSelectedToolPackId(meUser.preferred_tool_pack_id);
                        }
                        else if (allToolPacks.length > 0) {
                            // FALLBACK: Auto-select first tool pack
                            setSelectedToolPackId(allToolPacks[0].id);
                        }
                        // PRIORITY 1: Use initialRegisteredUserId if provided (from URL params)
                        if (initialRegisteredUserId &&
                            allRegisteredUsers.some(function (ru) { return ru.id === initialRegisteredUserId; })) {
                            setSelectedRegisteredUserId(initialRegisteredUserId);
                        }
                        // PRIORITY 2: Use user's preferred registered user if it exists and is in the list
                        else if ((meUser === null || meUser === void 0 ? void 0 : meUser.preferred_test_registered_user_id) &&
                            allRegisteredUsers.some(function (ru) { return ru.id === meUser.preferred_test_registered_user_id; })) {
                            setSelectedRegisteredUserId(meUser.preferred_test_registered_user_id);
                        }
                        else if (allRegisteredUsers.length > 0) {
                            // FALLBACK: Auto-select first registered user
                            setSelectedRegisteredUserId(allRegisteredUsers[0].id);
                        }
                        return [3 /*break*/, 5];
                    case 3:
                        error_1 = _b.sent();
                        console.error("Error fetching resources:", error_1);
                        return [3 /*break*/, 5];
                    case 4:
                        setIsLoadingResources(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        fetchResources();
    }, [authToken, apiBaseURL, useDummyResponse, customization === null || customization === void 0 ? void 0 : customization.initialToolPackId, customization === null || customization === void 0 ? void 0 : customization.initialRegisteredUserId]);
    // Create chat session if needed
    var createChatSession = function () { return __awaiter(void 0, void 0, Promise, function () {
        var session, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!selectedToolPackId || !selectedRegisteredUserId) {
                        console.error("Tool pack and registered user must be selected");
                        return [2 /*return*/, null];
                    }
                    setIsCreatingSession(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, createChatSessionAPI(apiBaseURL, authToken, selectedToolPackId, selectedRegisteredUserId, additionalSystemPrompt || undefined)];
                case 2:
                    session = _a.sent();
                    setChatSession(session);
                    setIsCreatingSession(false);
                    return [2 /*return*/, session];
                case 3:
                    error_2 = _a.sent();
                    console.error("Error creating chat session:", error_2);
                    setIsCreatingSession(false);
                    window.parent.postMessage({
                        messageType: "SEND_VALIDATION_ERROR_TO_PARENT",
                        error: "Failed to create chat session. Please try again.",
                    }, "*");
                    return [2 /*return*/, null];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    // Helper function to append a part to assistant message
    var appendPartToAssistantMessage = function (prevMessages, assistantMessageId, newPart) {
        var existingIndex = prevMessages.findIndex(function (m) { return m.id === assistantMessageId; });
        if (existingIndex >= 0) {
            var updated = __spreadArray([], prevMessages, true);
            var existing = updated[existingIndex];
            updated[existingIndex] = __assign(__assign({}, existing), { parts: __spreadArray(__spreadArray([], (existing.parts || []), true), [newPart], false) });
            return updated;
        }
        else {
            return __spreadArray(__spreadArray([], prevMessages, true), [
                {
                    id: assistantMessageId,
                    content: "",
                    role: "assistant",
                    timestamp: new Date(),
                    parts: [newPart],
                },
            ], false);
        }
    };
    // Helper function to handle function call events
    var handleFunctionCallData = function (obj, toolCallsMap, assistantMessageId, setIsLoading, setMessages) {
        var _a;
        setIsLoading(false);
        // Handle authentication tool calls specially
        if (isAuthenticateTool(obj.tool_name)) {
            var linkToken_1 = (_a = obj.result) === null || _a === void 0 ? void 0 : _a.link_token;
            if (!linkToken_1 && obj.status === "succeeded") {
                console.error("No link token received from authenticate_ function call. Contact admin");
            }
            else if (linkToken_1) {
                setMessages(function (prev) {
                    return appendPartToAssistantMessage(prev, assistantMessageId, {
                        type: "authenticateCall",
                        authenticateCall: {
                            connector: obj.connector,
                            linkToken: linkToken_1,
                            call_id: obj.call_id,
                        },
                    });
                });
            }
            return;
        }
        var toolCall = {
            connector: obj.connector,
            tool_name: obj.tool_name,
            call_id: obj.call_id,
            parameters: obj.parameters,
            result: obj.result,
            status: obj.status,
        };
        // Check if this tool call already exists
        var existingToolCall = toolCallsMap.get(obj.call_id);
        toolCallsMap.set(obj.call_id, toolCall);
        // Only append if this is a new tool call
        if (!existingToolCall) {
            setMessages(function (prev) {
                return appendPartToAssistantMessage(prev, assistantMessageId, {
                    type: "toolCall",
                    toolCall: toolCall,
                });
            });
        }
        else {
            // Update existing tool call in place
            setMessages(function (prev) {
                var existingIndex = prev.findIndex(function (m) { return m.id === assistantMessageId; });
                if (existingIndex >= 0) {
                    var updated = __spreadArray([], prev, true);
                    var msg = updated[existingIndex];
                    if (msg.parts) {
                        var parts = __spreadArray([], msg.parts, true);
                        var partIndex = parts.findIndex(function (p) { return p.type === "toolCall" && p.toolCall.call_id === obj.call_id; });
                        if (partIndex >= 0) {
                            parts[partIndex] = { type: "toolCall", toolCall: toolCall };
                            updated[existingIndex] = __assign(__assign({}, msg), { parts: parts });
                        }
                    }
                    return updated;
                }
                return prev;
            });
        }
    };
    // Helper function to handle text/string data
    var handleStringData = function (obj, assistantMessageId, setIsLoading, setMessages) {
        setIsLoading(false);
        var textToAdd = typeof obj === "string" ? obj : obj.text;
        // Update the last text part or append a new one
        setMessages(function (prev) {
            var existingIndex = prev.findIndex(function (m) { return m.id === assistantMessageId; });
            if (existingIndex >= 0) {
                var updated = __spreadArray([], prev, true);
                var msg = updated[existingIndex];
                var parts = msg.parts || [];
                var lastPart = parts[parts.length - 1];
                // If last part is text, append to it; otherwise create new text part
                if ((lastPart === null || lastPart === void 0 ? void 0 : lastPart.type) === "text") {
                    var newParts = __spreadArray([], parts, true);
                    newParts[newParts.length - 1] = {
                        type: "text",
                        content: lastPart.content + textToAdd,
                    };
                    updated[existingIndex] = __assign(__assign({}, msg), { parts: newParts });
                }
                else {
                    updated[existingIndex] = __assign(__assign({}, msg), { parts: __spreadArray(__spreadArray([], parts, true), [{ type: "text", content: textToAdd }], false) });
                }
                return updated;
            }
            else {
                return __spreadArray(__spreadArray([], prev, true), [
                    {
                        id: assistantMessageId,
                        content: "",
                        role: "assistant",
                        timestamp: new Date(),
                        parts: [{ type: "text", content: textToAdd }],
                    },
                ], false);
            }
        });
    };
    // Handle streaming response from SSE
    var handleStreamingResponse = function (userText, session) {
        // Close any existing event source
        if (eventSourceRef.current) {
            eventSourceRef.current.close();
        }
        var streamEndpoint = "".concat(apiBaseURL, "/api/chat/sessions/").concat(session.id, "/send/?userText=").concat(encodeURIComponent(userText), "&stream_token=").concat(session.stream_token);
        var source = new EventSource(streamEndpoint);
        eventSourceRef.current = source;
        var accumulatedText = "";
        var assistantMessageId = (Date.now() + 1).toString();
        var toolCallsMap = new Map(); // Track tool calls by call_id
        source.onmessage = function (e) {
            try {
                if (e.data === "[STREAM CLOSED]") {
                    source.close();
                    setIsLoading(false);
                    // Notify parent of success
                    window.parent.postMessage({
                        messageType: "SEND_SUCCESS_TO_PARENT",
                        message: accumulatedText,
                    }, "*");
                    return;
                }
                var obj = JSON.parse(e.data);
                // Handle exception events
                if (obj.event === "exception") {
                    console.error("Stream exception:", obj);
                    source.close();
                    setIsLoading(false);
                    // Append error part to message
                    setMessages(function (prev) {
                        return appendPartToAssistantMessage(prev, assistantMessageId, {
                            type: "error",
                            message: "Error in message stream",
                            onRetry: function () { return handleSendMessage(userText); },
                        });
                    });
                    return;
                }
                // Handle function call events
                if (obj.event === "function_call") {
                    handleFunctionCallData(obj, toolCallsMap, assistantMessageId, setIsLoading, setMessages);
                    return;
                }
                // Handle text chunks
                if (obj.text || typeof obj === "string") {
                    handleStringData(obj, assistantMessageId, setIsLoading, setMessages);
                    accumulatedText += typeof obj === "string" ? obj : obj.text;
                }
            }
            catch (error) {
                console.error("Failed to parse SSE data:", e.data, error);
            }
        };
        source.onerror = function (err) {
            console.error("SSE error or closed", err);
            source.close();
            setIsLoading(false);
            if (accumulatedText === "") {
                window.parent.postMessage({
                    messageType: "SEND_VALIDATION_ERROR_TO_PARENT",
                    error: "Failed to receive response. Please try again.",
                }, "*");
            }
        };
    };
    var handleSendMessage = function (messageToSend) { return __awaiter(void 0, void 0, void 0, function () {
        var textToSend, userMessage, messageText, session, error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    textToSend = messageToSend !== null && messageToSend !== void 0 ? messageToSend : inputValue;
                    if (!textToSend.trim() || isLoading || isCreatingSession)
                        return [2 /*return*/];
                    userMessage = {
                        id: Date.now().toString(),
                        content: textToSend,
                        role: "user",
                        timestamp: new Date(),
                    };
                    setMessages(function (prev) { return __spreadArray(__spreadArray([], prev, true), [userMessage], false); });
                    messageText = textToSend;
                    setInputValue("");
                    setIsLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 6, , 7]);
                    if (!useDummyResponse) return [3 /*break*/, 2];
                    // Dummy response mode
                    setTimeout(function () {
                        var assistantMessage = {
                            id: (Date.now() + 1).toString(),
                            content: "You're absolutely right",
                            role: "assistant",
                            timestamp: new Date(),
                        };
                        setMessages(function (prev) { return __spreadArray(__spreadArray([], prev, true), [assistantMessage], false); });
                        setIsLoading(false);
                        // Notify parent of success
                        window.parent.postMessage({
                            messageType: "SEND_SUCCESS_TO_PARENT",
                            message: assistantMessage.content,
                        }, "*");
                    }, 500);
                    return [3 /*break*/, 5];
                case 2:
                    session = chatSession;
                    if (!!session) return [3 /*break*/, 4];
                    return [4 /*yield*/, createChatSession()];
                case 3:
                    session = _a.sent();
                    if (!session) {
                        setIsLoading(false);
                        return [2 /*return*/];
                    }
                    _a.label = 4;
                case 4:
                    // Start streaming response
                    handleStreamingResponse(messageText, session);
                    _a.label = 5;
                case 5: return [3 /*break*/, 7];
                case 6:
                    error_3 = _a.sent();
                    console.error("Error sending message:", error_3);
                    setIsLoading(false);
                    // Notify parent of error
                    window.parent.postMessage({
                        messageType: "SEND_VALIDATION_ERROR_TO_PARENT",
                        error: "Failed to send message. Please try again.",
                    }, "*");
                    return [3 /*break*/, 7];
                case 7: return [2 /*return*/];
            }
        });
    }); };
    // Cleanup event source on unmount
    useEffect(function () {
        return function () {
            if (eventSourceRef.current) {
                eventSourceRef.current.close();
            }
        };
    }, []);
    // Apply a selection change, resetting conversation state
    var applySelectionChange = function (changeFn) {
        changeFn();
        setChatSession(null);
        setMessages([]);
        // Close any active SSE stream
        if (eventSourceRef.current) {
            eventSourceRef.current.close();
            eventSourceRef.current = null;
        }
        setIsLoading(false);
    };
    // Wrap selection change with confirmation if conversation has started
    var confirmAndApply = function (changeFn) {
        if (messages.length > 0) {
            pendingChangeRef.current = changeFn;
            setConfirmDialogOpen(true);
        }
        else {
            applySelectionChange(changeFn);
        }
    };
    var handleConfirm = function () {
        setConfirmDialogOpen(false);
        if (pendingChangeRef.current) {
            applySelectionChange(pendingChangeRef.current);
            pendingChangeRef.current = null;
        }
    };
    var handleConfirmCancel = function () {
        setConfirmDialogOpen(false);
        pendingChangeRef.current = null;
    };
    var handleToolPackChange = function (toolPackId) {
        confirmAndApply(function () { return setSelectedToolPackId(toolPackId); });
    };
    var handleRegisteredUserChange = function (registeredUserId) {
        confirmAndApply(function () { return setSelectedRegisteredUserId(registeredUserId); });
    };
    // Notify parent when selections change so it can update the URL
    useEffect(function () {
        if (selectedToolPackId || selectedRegisteredUserId) {
            sendSelectionChangeToParent(selectedToolPackId, selectedRegisteredUserId);
        }
    }, [selectedToolPackId, selectedRegisteredUserId]);
    var handleStopGeneration = function () {
        // Close the event source to stop streaming
        if (eventSourceRef.current) {
            eventSourceRef.current.close();
            eventSourceRef.current = null;
            setIsLoading(false);
        }
    };
    // Handle authentication connect button click
    var handleAuthenticateConnect = function (linkToken) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            // Open the link modal
            sendOpenLinkToParent(linkToken, apiBaseURL);
            return [2 /*return*/];
        });
    }); };
    // Get the selected tool pack object
    var selectedToolPack = toolPacks.find(function (tp) { return tp.id === selectedToolPackId; }) || null;
    // Determine if we should show compact layout (no messages sent yet)
    var isCompactMode = messages.length === 0;
    return (_jsxs("div", __assign({ className: "flex flex-col bg-white relative transition-all duration-700 ease-in-out h-full w-full gap-y-10 overflow-hidden" }, { children: [_jsxs("div", __assign({ className: "flex flex-col flex-1 overflow-hidden min-h-0" }, { children: [_jsx("div", __assign({ className: "rounded-t-xl bg-gray-0 px-3 py-1" }, { children: _jsx(PlaygroundURLBar, { apiBaseURL: apiBaseURL, authToken: authToken, toolPacks: toolPacks, registeredUsers: registeredUsers, selectedToolPack: selectedToolPack, selectedRegisteredUser: registeredUsers.find(function (ru) { return ru.id === selectedRegisteredUserId; }) || null, selectedToolPackId: selectedToolPackId, selectedRegisteredUserId: selectedRegisteredUserId, loading: isLoadingResources, onToolPackChange: handleToolPackChange, onRegisteredUserChange: handleRegisteredUserChange, onOpenInSelect: function (ideId) {
                                return sendOpenInToParent(ideId, selectedToolPackId, selectedRegisteredUserId);
                            }, onSettingsToggle: function () { return setIsSettingsPanelOpen(!isSettingsPanelOpen); } }) })), _jsx(Card, __assign({ variant: "outline", className: "flex w-full flex-1 flex-col overflow-hidden min-h-0 !rounded-t-none !border-t-0" }, { children: _jsxs("div", __assign({ className: "flex flex-col max-w-[800px] w-full h-full px-4 p-6 mx-auto flex-1 min-h-0" }, { children: [_jsx("div", __assign({ className: clsx("transition-all duration-1000 ease-in-out w-full overflow-hidden flex flex-col flex-1", isCompactMode ? "justify-end items-center gap-y-6" : "gap-y-4") }, { children: isCompactMode ? (_jsxs(_Fragment, { children: [_jsx("div", __assign({ className: "text-center" }, { children: _jsx(Text, __assign({ variant: "h2" }, { children: "Explore and test Merge Agent Handler" })) })), _jsx("div", __assign({ className: "w-full" }, { children: _jsx(ChatMessages, { messages: messages, isLoading: isLoading, onSuggestionClick: setInputValue, onSuggestionSend: handleSendMessage, onAuthenticateConnect: handleAuthenticateConnect, isCompactMode: true, authToken: authToken, apiBaseURL: apiBaseURL, selectedToolPack: selectedToolPack }) }))] })) : (_jsx("div", __assign({ className: "h-full w-full flex flex-col min-h-0" }, { children: _jsx(ChatMessages, { messages: messages, isLoading: isLoading, onSuggestionClick: setInputValue, onSuggestionSend: handleSendMessage, onAuthenticateConnect: handleAuthenticateConnect, isCompactMode: false, authToken: authToken, apiBaseURL: apiBaseURL, selectedToolPack: selectedToolPack }) }))) })), _jsx("div", __assign({ className: clsx("w-full flex flex-col transition-all duration-1000 ease-in-out", isCompactMode
                                        ? "flex-1 justify-start items-center"
                                        : "flex-shrink-0 mt-4") }, { children: _jsx(ChatInput, { value: inputValue, onChange: setInputValue, onSend: handleSendMessage, onStop: handleStopGeneration, isAwaitingResponse: isLoading, customization: customization }) }))] })) }))] })), !useDummyResponse && (_jsx(SettingsPanel, { isOpen: isSettingsPanelOpen, onClose: function () { return setIsSettingsPanelOpen(false); }, additionalSystemPrompt: additionalSystemPrompt, onAdditionalSystemPromptChange: setAdditionalSystemPrompt, hasMessages: messages.length > 0 })), _jsx(PlaygroundConfirmDialog, { open: confirmDialogOpen, onConfirm: handleConfirm, onCancel: handleConfirmCancel })] })));
};
